import { render, staticRenderFns } from "./Multiplexing.Detail.vue?vue&type=template&id=0f21ac06&"
import script from "./Multiplexing.Detail.vue?vue&type=script&lang=js&"
export * from "./Multiplexing.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports